export const sanitizeValue = <T>(value: T, originalValue: T): T | undefined => {
  return originalValue === "" ? undefined : value;
};

export const sanitizePhoneNumber = (value: string) => {
  if (!value) return value;

  const cleaned = value.replace(/[^\d+]/g, "");

  return cleaned.startsWith("+") ? cleaned : `+${cleaned}`;
};
